import useSWR, { useSWRConfig } from 'swr'
import { useEffect, useState } from 'react'
import { postCommentEdit } from '@/api/comment'
import { GetCommentSimpleResponse } from '@/types/comment'
import { Srp } from '@/types'
import { CompleteModal, RoundedButton } from '.'

interface Props {
  srpStatus: Srp
  summaryId: number
}
export const InputComment: React.FC<Props> = ({ srpStatus, summaryId }) => {
  const { mutate } = useSWRConfig()
  const { data } = useSWR<GetCommentSimpleResponse>(`/api/comment/${summaryId}`)

  // 学びメモ公開フラグ
  const [isOpening, setIsOpening] = useState(true)
  // 学びメモ
  const [text, setText] = useState('')
  // 保存完了モーダルのフラグ
  const [modalOpen, setModalOpen] = useState(false)
  // 保存成功フラグ
  const [success, setSuccess] = useState(false)
  /**
   * 保存するボタンクリック時
   */
  const onClickSave = async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    const res = await postCommentEdit(summaryId, isOpening, text)
    setSuccess(res.result)
    setModalOpen(true)
    // 「注目の学びメモ」を更新
    mutate(`/api//summary/pickup/${summaryId}?page=1&limit=3`)
  }

  useEffect(() => {
    if (data && data.comment_id > 0) {
      setText(data.comment)
      setIsOpening(data.is_opening)
    }
  }, [data])

  return (
    <>
      <div className="flex mb-[30px] w-full border-t border-[#e6e6e6] border-solid">
        <div className="relative mx-auto mt-[30px] min-h-[50px] font-medium text-center">
          <div className="text-2xl leading-6 text-black">
            <span className="text-center shadow-title">学びメモを書く</span>
          </div>
        </div>
      </div>
      <div className="px-5 mb-4 h-[167px]">
        <textarea
          className="p-[6px_12px] w-full h-full text-[#555] !bg-white rounded border-[0.5px] !border-[#707070] !shadow-none resize-none"
          value={text}
          placeholder="本要約から得た学びや気づき、実生活に応用したいポイントを記録しましょう"
          onChange={(e) => setText(e.target.value)}
        ></textarea>
      </div>
      <div className="flex px-1 xs:px-5">
        <div className="p-0 w-full">
          <div className="pb-2">
            {srpStatus !== Srp.OFF_SRP && (
              <label className="font-extralight cursor-pointer">
                <input
                  type="checkbox"
                  checked={isOpening}
                  onChange={() => setIsOpening(!isOpening)}
                />
                <span className="pl-2 text-sm">学びメモを公開する</span>
              </label>
            )}
            <div className="py-1 text-xs">
              {srpStatus === Srp.OFF_SRP ? (
                <span>
                  学びメモには個人情報（電話番号・メールアドレス等）を入力しないようにお願いいたします。
                </span>
              ) : (
                <span>
                  ガイドラインに違反する学びメモは非公開になることがあります。
                </span>
              )}
            </div>
          </div>
          <div className="text-center">
            <RoundedButton text="保存する" onClick={onClickSave} />
          </div>
        </div>
      </div>
      <CompleteModal
        isOpen={modalOpen}
        isSuccess={success}
        srpStatus={srpStatus}
        modalText={success ? '保存が完了しました' : '保存に失敗しました'}
        comment={text}
        summaryId={summaryId}
        onClose={() => setModalOpen(false)}
      />
    </>
  )
}
